<template>
  <div>
    <p>img</p>
    <div>
      <input type="file" v-on:change="upload($event.target.files)" accept="image/*">
    </div>
    <iframe v-bind:src="img" frameborder="0"></iframe>
  </div>
</template>

<script>
import axios from 'axios'
import { getAPIURL } from '@/store/getters.js'

export default {
  props: {
    user: Object
  },
  data () {
    return {
      img: '',
      cloudinary: {
        uploadPreset: 'hitx3cix',
        apiKey: '488353543644961',
        cloudName: 'dsvd2yusw'
      }
    }
  },
  computed: {
    clUrl () {
      return `https://api.cloudinary.com/v1_1/${this.cloudinary.cloudName}/upload`
    }
  },
  methods: {
    upload (file) {
      let that = this

      const formData = new FormData()
      formData.append('file', file[0])
      formData.append('upload_preset', that.cloudinary.uploadPreset)
      formData.append('tags', 'gs-vue,gs-vue-uploaded')
      // For debug purpose only
      // Inspects the content of formData
      for (var pair of formData.entries()) {
        console.log(pair[0] + ', ' + pair[1])
      }
      // Execute api
      axios.post(that.clUrl, formData).then(res => {
        console.log(res)
        that.img = res.data.secure_url
        let url = getAPIURL() + '/api/v1/users/' + that.user.id
        // let url = getAPIURL() + '/api/v1/user/'
        console.log(url)
        const params = {
          'img': res.data.secure_url
          // 'email': 'test@gmail.com'
        }
        console.log(params.img)
        axios({
          method: 'patch',
          params: params,
          url: url,
          withCredentials: true
        })
        .then(function (response) {
          console.log(response)
          alert('Success!!')
        })
      })
    }
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 231px);
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// UserImg.vue?5c29a78e